import * as Yup from 'yup';

// Uploaded values are browser `File` instances. Yup's `object()` type check rejects them
// (`Object.prototype.toString.call(file)` is '[object File]', not '[object Object]'), which would
// silently block submission, so the entries are left as `mixed()`.
export default Yup.object().shape({
  scheduleB: Yup.array().of(Yup.mixed()),
});
